module.exports = __webpack_public_path__ + "img/new2.918b6649.webp";